import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "sales-report",
      path: "report",
      meta: {
        auth: () =>
          store.getters.isSuper() || store.getters.hasRole("accounting"),
        icon: "sales_report",
        title: i18n.global.t("Sales Report"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/SalesReport"),
    },
  ],

  dialogs: [],
};
